const isFbqReady = () =>
  typeof window !== 'undefined' && typeof window.fbq === 'function'

const PENDING_PURCHASES_KEY = 'meta_pending_purchases'

export const trackPixelEvent = (eventName, params = {}) => {
  if (!isFbqReady()) return
  window.fbq('track', eventName, params)
}

export const trackPixelCustom = (eventName, params = {}) => {
  if (!isFbqReady()) return
  window.fbq('trackCustom', eventName, params)
}

const readPendingPurchases = () => {
  if (typeof window === 'undefined') return {}
  const rawValue = window.sessionStorage.getItem(PENDING_PURCHASES_KEY)
  if (!rawValue) return {}

  try {
    return JSON.parse(rawValue)
  } catch (_error) {
    return {}
  }
}

const writePendingPurchases = data => {
  if (typeof window === 'undefined') return
  window.sessionStorage.setItem(PENDING_PURCHASES_KEY, JSON.stringify(data))
}

export const savePendingPurchase = (orderId, payload) => {
  if (!orderId || !payload) return
  const purchases = readPendingPurchases()
  purchases[String(orderId)] = payload
  writePendingPurchases(purchases)
}

export const getPendingPurchase = orderId => {
  if (!orderId) return null
  const purchases = readPendingPurchases()
  return purchases[String(orderId)] || null
}

export const clearPendingPurchase = orderId => {
  if (!orderId) return
  const purchases = readPendingPurchases()
  delete purchases[String(orderId)]
  writePendingPurchases(purchases)
}
